/** One `details[]` entry of a BFF error body: a named reason, e.g. `payment_authentication` → `CHALLENGE_CANCELLED`. */
export interface ApiErrorDetail {
  name: string;
  reason: string;
}

/**
 * Custom error class for API-related errors
 *
 * Provides structured error information including HTTP status codes
 * and additional data from API responses
 */
export class ApiError<D = unknown> extends Error {
  status: number;
  data: D;

  constructor(message: string, status: number, data: D) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export interface ApiEvaluationResponse {
  severity: ApiEvaluationSeverity;
  /** Business code, e.g. "PASSENGER-COMPOSITION-ADULT-REQUIRED". */
  code: string;
  /** Evaluation response description. Always English. */
  detail: string;
}

/** Matches the design-system status vocabulary, so it is displayed as-is. */
export type ApiEvaluationSeverity = 'error' | 'warning' | 'info';